module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "page-empty"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-align"
  }, [_c('h4', [_vm._v("Coming soon! Projects is a new feature that will enable people to work together to create a sustainable Africa.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.testMailchimp
    }
  }, [_vm._v("Test Mailchimp")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-round green",
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("Add Data")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.testVariable))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d165069"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tests.vue
// module id = 699
// module chunks = 1